<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
      <div v-if="loaded">

      <h1 class="text-2xl mt-6"><span class="text-red-500">Valorant</span>Accounts.net In-House Boosting Service</h1>

      <h5 class="mt-2">While supplies last, the staff of <span class="text-red-500">Valorant</span>Accounts will be providing Boosting Services for Iron-Platinum accounts!</h5>
     
      <router-link to="/buy" class="text-red-500 text-xs underline">Psst! Want to play in ranks higher than Diamond? Check out the listings on the Buy Page!</router-link>
    

    <p class="">Staff members available for boosting right now:</p>
<ul class="list">
  <li><span class="text-red-500">V</span>A-Narcotics (Immortal II) (NA)</li>
  <li><span class="text-red-500">V</span>A-Thorn (Immortal III) (NA)</li>
  <li><span class="text-red-500">V</span>A-Balistix (Immortal II) (EU)</li>
  <li><span class="text-red-500">V</span>A-Dingo (Immortal III) (BR)</li>
    <li><span class="text-red-500">V</span>A-Toro (Immortal I) (LATAM)</li>        
</ul>

    <p class="mt-2">Staff members fully booked:</p>
<ul class="list line-through text-gray-700">
  <li><span class="text-red-700">V</span>A-Downtown (Radiant) (EU)</li>
 <li><span class="text-red-700">V</span>A-Genghis (Immortal III) (NA)</li>     
</ul>


<h3 class="text-3xl mt-4">Purchase Boosting</h3>
    <div class="w-1/3 m-auto  mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-city">
        Coupon Code
      </label>
      <input v-model="couponCode" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="coupon" type="text" placeholder="Enter code (if applicable)">
    </div>

        <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

        <button @click="applyCoupon"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Apply Coupon</button>

        </ul>

<p class="text-xs text-red-500" v-if="couponText" v-text="couponText"></p>


<p class="mt-8">My account is</p>

<div class="inline-block relative w-1/2 md:w-1/3 mt-2">
  <select v-model="startingRank" class="block appearance-none w-full bg-gray-700 border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
    <option>Iron I</option>
    <option>Iron II</option>
    <option>Iron III</option>
    <option>Bronze I</option>
    <option>Bronze II</option>
    <option>Bronze III</option>
    <option>Silver I</option>
    <option>Silver II</option>
    <option>Silver III</option>
    <option>Gold I</option>
    <option>Gold II</option>
    <option>Gold III</option>
    <option>Platinum I</option>
    <option>Platinum II</option>
    <option>Platinum III</option>                           
  </select>
  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-100">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
  </div>
</div>

<p class="mt-2">and I would like it to be boosted to</p>

<div class="inline-block relative w-1/2 md:w-1/3 mt-2">
  <select v-model="boostedRank" class="block appearance-none w-full bg-gray-700 border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
    <option>Bronze I</option>
    <option>Bronze II</option>
    <option>Bronze III</option>
    <option>Silver I</option>
    <option>Silver II</option>
    <option>Silver III</option>
    <option>Gold I</option>
    <option>Gold II</option>
    <option>Gold III</option>
    <option>Platinum I</option>
    <option>Platinum II</option>
    <option>Platinum III</option> 
    <option>Diamond I</option>
    <option>Diamond II</option>
    <option>Diamond III</option> 
    <option>Immortal I</option>                            
  </select>
  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-100">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
  </div>
</div>

<p class="mt-2">by</p>

<div class="inline-block relative w-1/2 md:w-1/3 mt-2">
  <select v-model="booster" class="block appearance-none w-full bg-gray-700 border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
    <option>VA-Narcotics (Immortal II) (NA)</option>
    <option>VA-Thorn (Immortal III) (NA)</option>
    <option>VA-Balistix (Immortal II) (EU)</option>
    <option>VA-Dingo (Immortal III) (BR)</option>
    <option>VA-Toro (Immortal I) (LATAM)</option>                           
  </select>
  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-100">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
  </div>
</div>

 <h5 class="mt-2">Boosting Method</h5>
<p class="text-xs">If you are not comfortable giving us your account details, we recommend the Indirect Boosting service.</p>
<div class="inline-block relative w-1/2 md:w-1/3 mt-2">
  <select v-model="boostType" class="block appearance-none w-full bg-gray-700 border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
    <option>Direct Boost (Login)</option>
    <option>Indirect Boost (Queue Together) (+25%)</option>                      
  </select>
  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-100">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
  </div>
</div>

<div v-if="boostType == 'Direct Boost (Login)'">
    <div class="w-full md:w-1/3 px-3 mb-6 m-auto mt-2 md:mb-0">

      <input v-model="riotName" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" type="text" placeholder="Riot Username">
      <p v-if="!riotName" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>

    <div class="w-full md:w-1/3 px-3 mb-6 m-auto mt-2 md:mb-0">

      <input v-model="riotPass" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" type="password" placeholder="Riot Password">
      <p v-if="!riotPass" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>

</div>
 <h5 class="mt-4 text-sm">1 Litecoin = {{ltcPrice}} USD (price from <a href="https://www.coingecko.com/en/coins/litecoin" class="underline">Coingecko</a>)</h5>
<p class="mt-2">Price for the Above Options</p>
<h4 class="text-2xl">${{calculatePrice()}} USD</h4>


<div v-if="multiplier != 1">
  <p class="mt-2">Price after Coupons</p>
<h4 class="text-2xl">${{Math.ceil(calculatePrice() * multiplier)}} USD</h4>

</div>

  <p class="mt-2">Final Price in Litecoin</p>
<h4 class="text-2xl">{{Math.round( Math.ceil(calculatePrice() * multiplier)/ltcPrice * 10000) / 10000.0}} LTC</h4>


    <div class="mt-8" v-if="userData.payAddress">



                <p>Your Litecoin Payments Address is set to: <span class="underline">{{userData.payAddress}}</span></p>
                <p class="text-red-500 uppercase text-xs">We will be expecting payment from this address!</p>





                <p class="mt-2">Click the button below to request a Litecoin Address to send payment.</p>

                <p v-if="boostType == 'Direct Boost (Login)'"  class="mt-2">Make sure your username and password is correct!</p>

<div v-if="boostType == 'Direct Boost (Login)' && riotName && riotPass || boostType == 'Indirect Boost (Queue Together) (+25%)'">
          <ul v-if="!addressRequested" class="flex justify-center w-1/4 m-auto mt-2 md:w-5/6 lg:w-1/3">

        <button @click="requestAddress"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Request Address</button>

        </ul>


            <div v-if="toAddress" class="mt-2">

                <p>Send {{Math.round( Math.ceil(calculatePrice() * multiplier)/ltcPrice * 10000) / 10000.0}} Litecoin to <span class="text-green-500">{{toAddress}}</span></p>

             <vue-qrcode class="m-auto mt-4" :value="toAddress" />


</div>


             </div>

                <p id="countdown"></p>

        <div v-if="toAddress">

            <p>Once <span class="text-green-500">{{toAddress}}</span> has received at least {{Math.round( Math.ceil(calculatePrice() * multiplier)/ltcPrice * 10000) / 10000.0}} Litecoin from <span class="text-red-500">{{userData.payAddress}}</span> , DON'T LOG IN UNTIL WE EMAIL YOU AT THE GMAIL ADDRESS YOU USED TO SIGN IN! If you paid for Indirect Boosting, you will be emailed by the Staff member you chose once payment is confirmed.</p>
            <p class="mt-2"> This process can take up to 30 minutes. If there are any issues at all, email us at buyers@<span class="text-red-500">Valorant</span>Accounts.net</p>

        </div>

          </div>

        <div v-else>
            <p class="text-red-500">You have not set your Litecoin Payment Address yet! Set it in your account settings!</p>
        </div>


      </div>

      <div v-else>
        Loading Boosting Info..
      </div>

    </div>
</template>


<script>
import firebase from 'firebase/app'
import db from '@/db'

import ltc from '@/ltc'

import axios from 'axios'

import VueQrcode from 'vue-qrcode'

const ranks = [
    "Iron I",
    "Iron II",
    "Iron III",
    "Bronze I",
    "Bronze II",
    "Bronze III",
    "Silver I",
    "Silver II",
    "Silver III",
    "Gold I",
    "Gold II",
    "Gold III",
    "Platinum I",
    "Platinum II",
    "Platinum III", 
    "Diamond I",
    "Diamond II",
    "Diamond III", 
    "Immortal I"
]

const rankPrices = [
    //Iron
    0,
    1,
    1,
    //Bronze
    2,
    2,
    2,
    //Silver
    3,
    3,
    3,
    //Gold
    4,
    4,
    4,
    //Platinum
    5,
    5,
    6,
    //Diamond
    7,
    8,
    9,
    //Immortal
    13

]

let userRef;

export default {
  name: 'BoostAccounts',
  components: {VueQrcode},
  data () {
    return {
        startingRank: 'Iron III',
        boostedRank: 'Silver I',
        boostType: 'Direct Boost (Login)',
        userData: {},
        riotName: '',
        riotPass: '',
        loaded: false,
        ltcPrice: 0,
        couponCode: '',
        multiplier: 1,
        couponText: '',
        toAddress: '',
        addressRequested: false,
        booster: 'VA-Narcotics (Immortal II) (NA)'        


    }
  },
 beforeMount(){




 axios.get("https://api.coingecko.com/api/v3/simple/price?ids=litecoin&vs_currencies=usd")
    .then(res => {
        this.ltcPrice = res.data.litecoin.usd

        this.checkCoupons();




        if (firebase.auth().currentUser) {

        userRef = db.collection("Users").doc(firebase.auth().currentUser.uid)

        return userRef.get()
        .then(doc => {
            this.userData = doc.data()
            this.loaded = true
            //Now get Litecoin conversion rate
            
        })

        } else {
          this.loaded = true;
        }

    })


 },
 methods: {
     calculatePrice() {
        
        let price = 0;
        
        let startIndex = ranks.indexOf(this.startingRank);

        let endIndex = ranks.indexOf(this.boostedRank);

        //console.log(rankPrices.slice(startIndex,endIndex+1))


        price = rankPrices.slice(startIndex+1,endIndex+1).reduce((total, next) => total + next, 0)

        if (this.boostType.length > 20) {
            price = Math.ceil(price*1.25)
        }


        return price;

     },
     purchaseBoosting() {
         alert("under development")
     },
    applyCoupon() {
        this.$router.replace({path: this.$route.path, query: {coupon: this.couponCode}})
        this.couponCode = ''
        this.checkCoupons();
    },
    requestAddress() {

        //First update the LTC price so we dont get finessed
        axios.get("https://api.coingecko.com/api/v3/simple/price?ids=litecoin&vs_currencies=usd")
        .then(res => {
            this.ltcPrice = res.data.litecoin.usd

            //Get a random address from the list
            this.toAddress = ltc[Math.round(Math.random()*200)]["1"];
            this.addressRequested = true

            const thirtyMinutes = 60 * 30;
            const display = document.querySelector('#countdown');
            this.startTimer(thirtyMinutes, display);

            //Save the data of the request to the database
            
            let paymentRequestData = {
                amountLTC: Math.round(Math.ceil(this.calculatePrice() * this.multiplier)/this.ltcPrice * 10000) / 10000.0,
                amountUSD: Math.ceil(this.calculatePrice() * this.multiplier),
                fromAddress: this.userData.payAddress,
                toAddress: this.toAddress,
                type: 'BOOSTING',
                when: new Date(),
                booster: this.booster,
                riotName: this.riotName,
                riotPass: this.riotPass
            }

            if (this.$route.query.coupon) {
              paymentRequestData.couponCode = this.$route.query.coupon
            }
            

            return db.collection("PaymentRequests").add(paymentRequestData)
        })
        .then(docRef => {

        })



    },
    checkCoupons() {

        //Setup coupon stuff too right now
        if (this.$route.query.coupon) {
            const coupon = this.$route.query.coupon.toUpperCase()
            if (coupon == 'NARCOTICS') {
                this.couponText = 'VA-Narcotics 20% Referral Coupon Applied!'
                this.multiplier = 0.8
            } else if (coupon == 'SIR20') {
                this.couponText = 'VA-Thorn 20% Referral Coupon Applied!'
                this.multiplier = 0.8
            }  else {
                this.couponText = "Coupon '"+coupon+"' does not exist!"
                this.multiplier = 1
            }
        }

    },
    
    startTimer(duration, display) {
        var start = Date.now(),
            diff,
            minutes,
            seconds;
        function timer() {
            // get the number of seconds that have elapsed since 
            // startTimer() was called
            diff = duration - (((Date.now() - start) / 1000) | 0);

            // does the same job as parseInt truncates the float
            minutes = (diff / 60) | 0;
            seconds = (diff % 60) | 0;

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds; 

            if (diff <= 0) {
                // add one second so that the count down starts at the full duration
                // example 05:00 not 04:59
                start = Date.now() + 1000;
            }
        };
        // we don't want to wait a full second before the timer starts
        timer();
        setInterval(timer, 1000);
    }      
 }    
}
</script>


// WEBPACK FOOTER //
// src/components/BoostAccounts.vue